import { Component } from '@angular/core';

import { trackByValue } from '@recruitee/common';

import { DialogComponentI, DialogRef } from '../../dialog/dialog.module';
import { IconName } from '../../icons-container/icons-container.module';

type IllustrationDialogResult = string | number;

interface IllustrationDialogButton {
  text: string;
  variant: 'primary' | 'default' | string;
  result?: IllustrationDialogResult;
  icon?: IconName;
  handler?: (dialogRef: DialogRef<IllustrationDialogComponent>) => void;
}

export interface IllustrationDialogData {
  imageSrc: string;
  message: string;
  description?: string;
  buttons: IllustrationDialogButton[];
}

@Component({
  selector: 'rt-congrats-dialog',
  templateUrl: './illustration-dialog.component.html',
  styleUrls: ['./illustration-dialog.component.less'],
})
export class IllustrationDialogComponent
  implements DialogComponentI<IllustrationDialogData, IllustrationDialogResult>
{
  public imageSrc: string;
  public message: string;
  public description?: string;
  public buttons: IllustrationDialogButton[];
  public trackByValue = trackByValue;

  constructor(private dialogRef: DialogRef<IllustrationDialogComponent>) {}

  public setDialogData(data: IllustrationDialogData): void {
    this.imageSrc = data.imageSrc;
    this.message = data.message;
    this.buttons = data.buttons;
    this.description = data.description;
  }

  public close(button: IllustrationDialogButton): void {
    button.handler ? button.handler(this.dialogRef) : this.dialogRef.close(button.result);
  }
}
